import CollaborationService from './CollaborationService';

class CodilityService implements CollaborationService {
  readonly name = 'Codility';

  readonly logoUrl = '/static/images/integrations/codility.png';
}

export default new CodilityService();
